import { CONDITION_REVIEW_VARIANT, CONDITION_ROW_STATE } from '../ConditionReviewList.constants';

const REMOVED_OPACITY = 0.5;
const FULL_OPACITY = 1;

const resolveItemBackground = ({ palette }, variant) =>
  variant === CONDITION_REVIEW_VARIANT.CHAT ? palette.background.paper : palette.background.default;

export const getItemStyles = (theme, { variant, rowState }) => {
  const { palette } = theme;
  const isEditing = rowState === CONDITION_ROW_STATE.EDIT;
  const isRemoved = rowState === CONDITION_ROW_STATE.REMOVE;

  return {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    padding: 1.5,
    borderRadius: 1.5,
    backgroundColor: resolveItemBackground(theme, variant),
    border: `1px solid ${isEditing ? palette.primary.main : palette.divider}`,
    boxShadow: isEditing ? `0 0 0 1px ${palette.primary.main}` : 'none',
    opacity: isRemoved ? REMOVED_OPACITY : FULL_OPACITY,
  };
};

export const getLineStyles = ({ palette }, { isRemoved }) => ({
  color: palette.text.primary,
  paddingRight: 10,
  textDecoration: isRemoved ? 'line-through' : 'none',
  textDecorationColor: palette.text.disabled,
});

export const fieldLabelStyles = ({ palette }) => ({
  color: palette.text.secondary,
  textTransform: 'uppercase',
});

export const actionsRowStyles = {
  position: 'absolute',
  top: 1,
  right: 1,
  display: 'flex',
  gap: 0.25,
};

export const quietActionButtonStyles = ({ palette }) => ({
  color: palette.text.secondary,
});

export const removeActionButtonStyles = ({ palette }) => ({
  color: palette.text.secondary,
  '&:hover': {
    color: palette.error.main,
  },
});

export const addBackButtonStyles = ({ palette }) => ({
  color: palette.primary.main,
});

export const editFieldsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const editRowStyles = {
  display: 'flex',
  gap: 1,
};

export const editBorrowerFieldStyles = {
  flex: 1,
};

export const editPriorToFieldStyles = {
  width: 140,
  flexShrink: 0,
};

export const editFooterStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1,
  marginTop: 1,
};

export const editTasksContainerStyles = ({ palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  marginTop: 0.5,
  paddingTop: 1,
  borderTop: `1px solid ${palette.divider}`,
});

export const editTaskRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const editTaskNameStyles = ({ palette }) => ({
  flex: 1,
  color: palette.text.primary,
});

export const editTaskAssigneeFieldStyles = {
  width: 180,
  flexShrink: 0,
};

export const tasksContainerStyles = ({ palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 0.25,
  marginTop: 0.5,
  paddingTop: 0.5,
  borderTop: `1px solid ${palette.divider}`,
});

export const getTaskLineStyles = ({ palette }, { isRemoved }) => ({
  display: 'flex',
  gap: 0.5,
  color: palette.text.primary,
  textDecoration: isRemoved ? 'line-through' : 'none',
  textDecorationColor: palette.text.disabled,
});

export const taskAssigneeStyles = ({ palette }) => ({
  color: palette.text.secondary,
});

export const sendBackContainerStyles = ({ palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  marginTop: 1,
  paddingTop: 1,
  borderTop: `1px solid ${palette.divider}`,
});

export const sendBackHeaderStyles = ({ palette }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  color: palette.primary.main,
});

export const sendBackNoteStyles = ({ palette }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  color: palette.text.secondary,
});
